/// <reference types="@angular/localize" />

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { browserTracingIntegration } from '@sentry/angular';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
    enabled: null !== environment.sentryDsn,
    dsn: environment.sentryDsn || undefined,
    release: environment.sentryRelease,
    environment: environment.environment,
    integrations: [
        browserTracingIntegration(),
    ],
    tracePropagationTargets: [
        'localhost',
        'https://tool.nachhaltigaustria.at/api',
        'https://tool.nachhaltigaustria.at.webmozarts.com/api',
    ],
    tracesSampleRate: environment.sentryTracesSampleRate,
    ignoreErrors: [
        'Non-Error exception captured',
    ],
    attachStacktrace: true,
});

if (environment.production) {
    enableProdMode();
}

platformBrowser().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
